import { daysBetween } from "../../../../app/utils/date";

export const formatDaysLeftToApply = (applicationDeadline: string) => {
  const applicationDeadlineDate = applicationDeadline && applicationDeadline !== ''
    ? new Date(Number(applicationDeadline)  * 1000)
    : null;

  if (applicationDeadlineDate) {
    const daysLeft: number = daysBetween(new Date(), applicationDeadlineDate);
    if(daysLeft < 0){
      return 'Application period closed'
    }
    else if(daysLeft === 0){
      return 'Last day to apply'
    }
    else if(daysLeft === 1){
      return '1 day to apply'
    }
    else
      return `${daysLeft} days to apply`
  } 
  else{
   return null
  } 
}